import DepthScroller from "@components/core/DepthScroller";

import { asset, config } from "./config";

export default function VOStudioHero() {
  const items = config.map(item => <Item key={item.asset} {...item} />);
  return <DepthScroller asset={<Asset />} items={items} />;
}

function Item({ asset }: { asset: string }) {
  return (
    <div className='relative h-full w-[150px] overflow-hidden xxl:w-[350px]'>
      <img alt='A close-up of a UI element from VoiceOver Studio' src={asset} />
    </div>
  );
}

function Asset() {
  return (
    <div
      className='overflow-hidden rounded-md shadow-[0px_0px_32px_rgba(0,0,0,0.16)] backdrop-blur-md md:rounded-lg md:shadow-[0px_0px_48px_rgba(0,0,0,0.16)]'
      style={{ backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)" }}
    >
      <img
        alt='A screenshot of the ElevenLabs Projects UI'
        className='h-full w-full opacity-100 md:opacity-90'
        src={asset}
      />
    </div>
  );
}
